export class WorkflowConstants {
    public static readonly taskWorkflowType = "Task";
    public static readonly appointmentWorkflowType = "Appointment";
    public static readonly medicationType = "MedicationType";
    public static readonly pathway = "Pathway";
    public static readonly carePlan = "CarePlan";
    public static readonly interventions = "Intervention";
    public static readonly eligibility = "Eligibility";
    public static readonly goal = "Goal";
    public static readonly open = "Open";
    public static readonly inProgress = "In-progress";
}

export class WorkflowStateConstants {
    public static readonly APPOINTMENT_PLANNED = "Planned";
    public static readonly APPOINTMENT_RESCHEDULED = "Rescheduled";
    public static readonly NEEDS_ACTION = "Needs Action";
    public static readonly IN_PROGRESS = "In-Progress";
    public static readonly COMPLETED = "Completed";
    public static readonly DONE = "Done";
    public static readonly ReviewPending = "Review Pending"
    public static readonly CANCELED = "Canceled";
}

export class EligibilityWorkflowStateConstants {
    public static readonly UNATTEMPTED = "Unattempted";
    public static readonly CALL_BACK_NO_ANSWER = "Call Back (No answer)";
    public static readonly CALL_BACK_LVM = "Call Back (LVM)";
    public static readonly CALL_BACK_REQUESTED_MORE_INFO = "Call Back (Requested more info)";
    public static readonly WRONG_NUMBER = "Wrong Number";
    public static readonly UNABLE_TO_REACH = "Unable to Reach";
}

export class ProgramConstants {
    public static readonly PULMONARY_DISEASE = "002966c1-56fd-43c6-95e0-d38c3824af6f";
    public static readonly DUAL_PULMONARY_AND_HF = "560d9e63-d460-4c74-87d2-9c12e4790d2e";
    public static readonly HEART_FALIURE = "e60c460c-1fce-4eee-a4f1-d5d9ec6fb38b";
    public static readonly NEW_PATIENT = "eeaf9408-a6c9-4b7d-b546-0ef9d0088416";
}

export class PathwaysConstants {
    public static readonly POST_ACUTE = "b3c22e8d-1c27-4f2b-9197-f251d3a7514d";
    public static readonly BASIC = "68ee10d8-d498-49a2-9324-8defe4a6471e";
    public static readonly ONWARD_AND_UPWARD = "36128f0e-2419-4a70-a3fc-2d405ea8aef6";
    public static readonly MAINTENANCE = "e67eb0a4-e04d-4f6e-9841-67b559f764af";
}

export class DesignerIdConstants {
    public static readonly ELIGIBILITY = "69f4d743-a7e7-4a00-bc71-ee77c2a205ed";
    public static readonly PATHWAY = "0c6b52a2-182d-4e83-b955-143d0ace76a5";
}

export class AppointmentHistoryConstants{
    public static readonly APPOINTMENT_RESCHEDULED = 'Rescheduled';
    public static readonly APPOINTMENT_STATUS = 'Status Updated';
    public static readonly APPOINTMENT_TYPE_CHANGES = 'Appointment type changed';
    public static readonly APPOINTMENT_MODE_CHANGES = 'Appointment mode changed';
    public static readonly APPOINTMENT_CREATED = 'Created';
    public static readonly APPOINTMENT_FIELD_TIME = 'time';
    public static readonly APPOINTMENT_STATUS_FIELD = 'status';
    public static readonly APPOINTMENT_FIELD_MODE = 'mode';
    public static readonly APPOINTMENT_FIELD_TYPE = 'type';
    public static readonly APPOINTMENT_FIELD_CREATED = 'createdby';
}

export class TimeZoneConstants {
    public static readonly UTC = "UTC";
    public static readonly EST = "America/New_York";
    public static readonly CST = "CST";
}